import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalPurchaseSection() {
  return <section className="py-8 md:py-16 px-3 bg-brand-dark border-b border-white/10" data-id="element-65">
      <div className="max-w-4xl mx-auto" data-id="element-66">
        <div className="text-center mb-8" data-id="element-67">
          <div className="inline-block bg-brand-accent/10 text-brand-accent font-black px-6 py-2 rounded-full mb-4 border-2 border-brand-accent animate-pulse text-sm md:text-base tracking-widest uppercase shadow-[0_0_15px_rgba(234,179,8,0.3)]" data-id="element-68">
            ⏰ EL PRECIO CIERRA EN
          </div>
          <div className="mb-6" data-id="element-69">
            <CountdownTimer data-id="element-70" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-71">
          {/* Premium Kit */}
          <div className="bg-brand-card rounded-2xl border-4 border-brand-accent p-5 md:p-6 flex flex-col relative shadow-[0_0_30px_rgba(234,179,8,0.2)] order-1" data-id="element-72">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-accent text-black font-black px-6 py-1.5 rounded-full text-xs md:text-sm tracking-widest shadow-lg whitespace-nowrap uppercase border-2 border-brand-dark" data-id="element-73">
              MÁS ELEGIDO ⭐
            </div>

            <div className="mb-4 mt-2" data-id="element-74">
              <h3 className="text-lg md:text-xl font-black text-white mb-2 flex items-start uppercase leading-tight" data-id="element-75">
                <span className="text-2xl mr-2" data-id="element-76">🏆</span>
                <span data-id="element-77">KIT COMPLETO + UPSELL PREMIUM ⭐</span>
              </h3>
              <p className="text-brand-accent font-black text-sm uppercase tracking-wide" data-id="element-78">
                6 Tomos + 4 Bonos + Upsell
              </p>
            </div>

            <div className="mb-6 flex-grow flex items-end" data-id="element-79">
              <div className="flex flex-col items-center w-full bg-black rounded-xl py-4 border border-brand-accent/20" data-id="element-80">
                <span className="text-base text-gray-500 line-through font-black mb-1" data-id="element-81">
                  $63.000 ARS
                </span>
                <span className="text-4xl md:text-5xl font-black text-brand-accent neon-glow" data-id="element-82">
                  $27.990{' '}
                  <span className="text-xl text-brand-accent/70" data-id="element-83">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47960408817902:1" className="py-4 md:py-5 text-base md:text-lg w-full shadow-[0_0_20px_rgba(234,179,8,0.4)]" pulse={true} data-id="element-84">
              → QUIERO EL KIT COMPLETO
            </Button>
          </div>

          {/* Basic Kit */}
          <div className="bg-brand-card rounded-2xl border-2 border-white/20 p-5 md:p-6 flex flex-col relative order-2 hover:border-brand-accent/50 transition-colors" data-id="element-85">
            <div className="mb-4" data-id="element-86">
              <h3 className="text-lg md:text-xl font-black text-white mb-2 flex items-center uppercase leading-tight" data-id="element-87">
                <span className="text-2xl mr-2" data-id="element-88">📘</span> KIT MANTENIMIENTO
                INDUSTRIAL LISTO
              </h3>
              <p className="text-brand-accent font-black text-sm uppercase tracking-wide" data-id="element-89">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="mb-6 flex-grow flex items-end" data-id="element-90">
              <div className="flex flex-col items-center w-full bg-white/5 rounded-xl py-4" data-id="element-91">
                <span className="text-base text-gray-500 line-through font-black mb-1" data-id="element-92">
                  $45.000 ARS
                </span>
                <span className="text-4xl md:text-5xl font-black text-white" data-id="element-93">
                  $19.990 <span className="text-xl text-gray-400" data-id="element-94">ARS</span>
                </span>
              </div>
            </div>

            <Button href="https://checkout.kitonline.shop/cart/47960406851822:1" className="py-4 text-sm md:text-base w-full" pulse={false} data-id="element-95">
              → QUIERO MI KIT AHORA
            </Button>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mt-8 text-xs md:text-sm text-gray-300 font-bold bg-brand-card py-4 px-2 rounded-xl border border-white/10 shadow-lg uppercase tracking-wide" data-id="element-96">
          <div className="flex items-center" data-id="element-97">
            <Lock className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-98" />
            <span data-id="element-99">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-100">
            <Zap className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-101" />
            <span data-id="element-102">Acceso en 5 minutos</span>
          </div>
          <div className="flex items-center" data-id="element-103">
            <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-104" />
            <span data-id="element-105">Garantía 7 días</span>
          </div>
          <div className="flex items-center w-full justify-center mt-2 pt-2 border-t border-white/5" data-id="element-106">
            <CreditCard className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-107" />
            <span data-id="element-108">Mercado Pago | Tarjeta | Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}